<template>
    <!-- usePagination开启分页 -->
    <!-- loading绑定引入页面的蒙层加载变量 -->
    <q-container usePagination :loading="loading">
        <!-- 使用具名插槽 #toolbar -->
        <!-- #toolbar可替换成slot="toolbar" #井号只是语法糖 -->
        <template #toolbar>
            <a-row>
                <a-col :span="14">
                    <a-button :type="'primary'" @click="Create()" v-if="isGranted('login_user_add')">
                        <a-icon type="plus" />
                        <span>{{ l('Create') }}</span>
                    </a-button>
                    <a-button :type="'primary'" @click="Edit()" v-if="isGranted('login_user_edit')">
                        <a-icon type="edit" />
                        <span>{{ l('Edit') }}</span>
                    </a-button>

                    <a-button type="primary" @click="Import" v-if="isGranted('login_user_import')">
                        <a-icon type="import" />
                        {{l('import')}}
                    </a-button>

                    <a-button type="default" @click="syncWeComUsers" v-if="weComEnabled">
                        <a-icon type="sync" />
                        同步企业微信
                    </a-button>

                    <a-dropdown :placement="'bottomRight'" v-if="isdropdown">
                        <a-button @click="(e) => e.preventDefault()">
                            {{ l('Action') }}
                            <a-icon type="down" />
                        </a-button>
                        <a-menu slot="overlay">
                            <!-- 使用此用户登录 -->
                            <a-menu-item @click="tenantImpersonateLogin()"
                                v-if="isGranted('login_user_login_thisuser')">
                                <span>
                                    <a-icon type="login" />
                                    <span>{{ l('LoginAsThisUser') }}</span>
                                </span>
                            </a-menu-item>
                            <!-- 功能授权 -->
                            <a-menu-item @click="userAuthorize()" v-if="isGranted('login_user_authorize')">
                                <span>
                                    <a-icon type="codepen" />
                                    <span>{{ l('功能授权') }}</span>
                                </span>
                            </a-menu-item>
                            <!-- 数据授权 -->
                            <!-- <a-menu-item @click="interfaceAuthorize()" v-if="isGranted('interface_authorize')">
								<span>
									<a-icon type="codepen" />
									<span>{{ l('鏁版嵁鎺堟潈') }}</span>
								</span>
							</a-menu-item> -->
                            <!-- 限制终端 -->
                            <a-menu-item @click="restrictClient()" v-if="isGranted('restrict_client_anthorize')">
                                <span>
                                    <a-icon type="codepen" />
                                    <span>{{ l('限制终端') }}</span>
                                </span>
                            </a-menu-item>
                            <!-- 清空缓存 -->
                            <a-menu-item @click="emptyUserToken()"
                                v-if="isTenantAdmin == 1 || isGranted('login_user_empty_token')">
                                <span>
                                    <a-icon type="codepen" />
                                    <span>{{ l('清空缓存') }}</span>
                                </span>
                            </a-menu-item>
                            <!-- 修改 -->
                            <!-- <a-menu-item @click="Edit()" v-if="isGranted('login_user_edit')">
								<span>
									<a-icon type="edit" />
									<span>{{ l('Edit') }}</span>
								</span>
							</a-menu-item> -->
                            <!-- 解锁 -->
                            <a-menu-item @click="unlockTenantAdminUser()" v-if="isGranted('login_user_unlock')">
                                <span>
                                    <a-icon type="unlock" />
                                    <span>{{ l('Unlock') + '/' + l('UserLockOut')  }}</span>
                                </span>
                            </a-menu-item>
                            <!-- 删除 -->
                            <a-menu-item @click="BatchDelete()" style="color: red;"
                                v-if="isGranted('login_user_delete')">
                                <a-icon type="delete" />
                                <span>{{ l('Delete') }}</span>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </a-col>
                <a-col :span="8" offset="2" style="text-align: right;">
					<a-checkbox v-model="islock" @change="getData()" style="margin-right: 10px;margin-top: 5px;">
					    {{l("UserLockOut")}}
					</a-checkbox>
                    <a-input-search name="filterText" :placeholder="l('SearchWithThreeDot')" @search="search"
                        enterButton v-model="filterText" style="width: 250px" />
                </a-col>
            </a-row>
        </template>
        <!-- 使用具名插槽slot="table" -->
        <!-- 插槽作用域的变量 slot-scope="scopeParam" -->
        <!-- 通过使用scopeParam.scroll.y 获取组件内部计算y值 -->

        <!-- **************行选择*************** -->
        <!-- customRow需要选择表格时添加属性和同名方法，方法不需要重新，在混入里面 -->
        <!-- 行选择默认单选，多选需要再data重写变量 isMultiple 并赋值true -->
        <template slot="table" slot-scope="scopeParam">
            <a-table ref="table" size="small" :pagination="false" :columns="columns"
                :rowKey="(tableDatas) => tableDatas.id" :scroll="{ x: 1640, y: scopeParam.scroll.y }" :dataSource="tableData"
                :customRow="customRow" :rowClassName="rowClassName">
                <span slot="UserImg" slot-scope="text, record">
                    <a-avatar shape="square" size="large" icon="user"
                        :src="imgPath + record.profilePictureId + record.userPictureType"
                        v-if="record.profilePictureId && record.userPictureType" />
                    <a-avatar shape="square" size="large" style="backgroundColor:rgb(0, 162, 174)" v-else>
                        {{ record.realName ? record.realName : record.userName }}
                    </a-avatar>
                </span>
                <span slot="enableAPPPush" slot-scope="text,record">
                    <a-icon type="check" style="color: green" v-if="text == true" />
                    <a-icon type="close" style="color: red" v-else />
                </span>
                <span slot="enableEmail" slot-scope="text,record">
                    <a-icon type="check" style="color: green" v-if="text == true" />
                    <a-icon type="close" style="color: red" v-else />
                </span>
                <span slot="enableWeComMessage" slot-scope="text,record">
                    <a-icon type="check" style="color: green" v-if="text == true" />
                    <a-icon type="close" style="color: red" v-else />
                </span>
                <span slot="enableDingTalkMessage" slot-scope="text,record">
                    <a-icon type="check" style="color: green" v-if="text == true" />
                    <a-icon type="close" style="color: red" v-else />
                </span>
                <span slot="weComSynced" slot-scope="text,record">
                    <a-icon type="check" style="color: green" v-if="text == true" />
                    <a-icon type="close" style="color: red" v-else />
                </span>
                <span slot="dingTalkSynced" slot-scope="text,record">
                    <a-icon type="check" style="color: green" v-if="text == true" />
                    <a-icon type="close" style="color: red" v-else />
                </span>
                <span slot="roles" slot-scope="text, record">
                    <a-tag color="#2db7f5" v-for="(item, index) in record.roles" :key="index">
                        {{ item.roleName }}
                    </a-tag>
                </span>
                <span slot-scope="text, record" slot="isLockoutEnabled">
                    <a-icon type="lock" v-if="record.isLockoutEnabled" />
                </span>
            </a-table>
        </template>
        <!-- 使用具名插槽 #page -->
        <template #page>
            <!-- 分页组件只需复制以下代码 -->
            <!-- 处理逻辑和变量都在 app-component-base混入文件 -->
            <a-pagination v-model="pageNumber" :total="totalItems" showSizeChanger size="small"
                :defaultPageSize="request.maxResultCount" :pageSizeOptions="pageSizeOptions"
                :showTotal="() => showTotal" @change="onPageChange" @showSizeChange="showPageSizeChange" />
        </template>
    </q-container>
</template>

<script>
    import { AppComponentBase } from '../../../shared/component-base';
    import { UserServiceProxy, TenantSettingsServiceProxy } from '../../../shared/service-proxies';
    import { AppConsts } from '../../../abpPro/AppConsts';
    import * as _ from 'lodash';
    import ModalHelper from '../../../shared/helpers/modal/modal-helper';
    import CreateOrEditLoginUser from './create-or-edit-login-user/create-or-edit-login-user';
    import Authorize from '../../admin/roles/authorize/authorize';
    import EditUserPermissionsComponent from '../../admin/users/edit-user-permissions/edit-user-permissions';
    import { impersonationService } from '../../../shared/auth';
    import { appSessionService } from '@/shared/abp';
    import { abpService } from '../../../shared/abp';
    import InterfaceAuthorize from '../../../app/admin/roles/interface-authorize/interface-authorize';
    import { TokenAuthServiceProxy, AccountsApiServiceProxy, AccountServiceProxy } from '@/shared/service-proxies';
    import RestrictClient from '../../../app/admin/roles/restrict-client/restrict-client';
    import ImportExcelModel from './import-excel-model/import-excel-model';

    export default {
        name: 'login-user',
        mixins: [AppComponentBase],
        components: { CreateOrEditLoginUser, InterfaceAuthorize, RestrictClient },
        data() {
            return {
                WorkTypeList: [],

                columns: [
                    {
                        title: this.l('Avatar'),
                        dataIndex: 'UserImg',
                        width: 70,
                        sorter: false,
                        align: 'center',
                        scopedSlots: { customRender: 'UserImg' },
                    },
                    {
                        title: this.l('UserName'),
                        dataIndex: 'userName',
                        sorter: false,
                        align: 'center',
                        ellipsis: true,
                        scopedSlots: { customRender: 'userName' },
                        width: 110,
                    },
                    {
                        title: this.l('DisplayName'),
                        dataIndex: 'realName',
                        sorter: false,
                        align: 'center',
                        ellipsis: true,
                        scopedSlots: { customRender: 'realName' },
                        width: 110,
                    }, {
                        title: this.l('EmailAddress'),
                        dataIndex: 'emailAddress',
                        sorter: false,
                        align: 'center',
                        ellipsis: true,
                        width: 180,
                    },
                    {
                        title: this.l('Roles'),
                        dataIndex: 'roles',
                        sorter: false,
                        align: 'center',
                        scopedSlots: { customRender: 'roles' },
                        width: 160,
                    },
                    {
                        title: this.l('APPPush'),
                        dataIndex: 'enableAPPPush',
                        width: 100,
                        sorter: false,
                        align: 'center',
                        ellipsis: true,
                        scopedSlots: { customRender: 'enableAPPPush' },
                    },
                    {
                        title: this.l('EmailPush'),
                        dataIndex: 'enableEmail',
                        width: 100,
                        sorter: false,
                        align: 'center',
                        ellipsis: true,
                        scopedSlots: { customRender: 'enableEmail' },
                    },
                    {
                        title: this.l('WeComNotify'),
                        dataIndex: 'enableWeComMessage',
                        width: 110,
                        sorter: false,
                        align: 'center',
                        ellipsis: true,
                        scopedSlots: { customRender: 'enableWeComMessage' },
                    },
                    {
                        title: this.l('WeComSync'),
                        dataIndex: 'weComSynced',
                        sorter: false,
                        align: 'center',
                        width: 120,
                        ellipsis: true,
                        scopedSlots: { customRender: 'weComSynced' },
                    },
                    {
                        title: this.l('DingTalkNotify'),
                        dataIndex: 'enableDingTalkMessage',
                        width: 110,
                        sorter: false,
                        align: 'center',
                        ellipsis: true,
                        scopedSlots: { customRender: 'enableDingTalkMessage' },
                    },
                    {
                        title: this.l('DingTalkSync'),
                        dataIndex: 'dingTalkSynced',
                        sorter: false,
                        align: 'center',
                        width: 120,
                        ellipsis: true,
                        scopedSlots: { customRender: 'dingTalkSynced' },
                    },
                    {
                        title: this.l('WeaverUserId'),
                        dataIndex: 'weaverUserId',
                        align: 'center',
                        width: 120,
                        customRender: (text) => {
                            return text ? text : '-';
                        },
                    },
                    {
                        title: this.l('Locked'),
                        dataIndex: 'isLockoutEnabled',
                        align: 'center',
                        scopedSlots: { customRender: 'isLockoutEnabled' },
                        width: 90,
                    },
                    {
                        title: this.l('Remark'),
                        dataIndex: 'remarks',
                        width: 220,
                        align: 'center',
                        ellipsis: true,
                        scopedSlots: { customRender: 'remarks' },
                    },
                ],
                tableData: [],
                imgPath: `${AppConsts.remoteServiceBaseUrl}/${AppConsts.localization.defaultLocalizationSourceName}/UserPicture/${abp.session.tenantId}/`,
                islock:false,
                weComEnabled: false,
            };
        },
        computed: {
            isTenantAdmin() {
                return abpService.abp.userInfo.isTenantAdmin;
            },
            isdropdown() {
                return (
                    this.isGranted('login_user_login_thisuser') ||
                    this.isGranted('login_user_authorize') ||
                    this.isGranted('login_user_empty_token') ||
                    this.isGranted('login_user_edit') ||
                    this.isGranted('login_user_unlock') ||
                    this.isGranted('login_user_delete')
                );
            },
        },
        created() {
            this._userServiceProxy = new UserServiceProxy(this.$apiUrl, this.$api);
            this._tenantSettingServiceProxy = new TenantSettingsServiceProxy(this.$apiUrl, this.$api);
            this._appSessionService = appSessionService;
            this.tokenAuthService = new TokenAuthServiceProxy(this.$apiUrl, this.$api);
            this.accountsApiService = new AccountsApiServiceProxy(this.$apiUrl, this.$api);
            this.accountService = new AccountServiceProxy(this.$apiUrl, this.$api);
        },
        mounted() {
            this.search();
            this.getWeComSetting();
        },
        methods: {

            //导入
            Import() {
                ModalHelper.create(
                    ImportExcelModel,
                    {
                    },
                    {
                        width: "800px"
                    }
                ).subscribe(res => {
                    this.getData();
                });
            },

            getData() {
                this.loading = true;
                this._userServiceProxy
                    .getLoginUserPage(
                        this.islock,
                        this.filterText,
                        this.request.sorting,
                        this.request.maxResultCount,
                        this.request.skipCount
                    )
                    .finally(() => {
                        this.loading = false;
                    })
                    .then((res) => {
                        this.tableData = res.items;
                        this.tableData.map((item) => {
                            item.checked = false;
                        });
                        this.totalItems = res.totalCount;
                        this.totalPages = Math.ceil(res.totalCount / this.request.maxResultCount);
                        this.pagerange = [
                            (this.pageNumber - 1) * this.request.maxResultCount + 1,
                            this.pageNumber * this.request.maxResultCount,
                        ];
                    });
            },
            getWeComSetting() {
                this._tenantSettingServiceProxy
                    .getAllSettings()
                    .then((res) => {
                        const settings = (res && res.result) || res || {};
                        this.weComEnabled = !!(settings.weCom && settings.weCom.enabled);
                    });
            },
            syncWeComUsers() {
                this.loading = true;
                this._userServiceProxy
                    .syncWeComUsers()
                    .finally(() => {
                        this.loading = false;
                    })
                    .then((res) => {
                        const result = res || {};
                        const getCount = (camelKey, pascalKey) =>
                            Number(result[camelKey] ?? result[pascalKey] ?? 0);
                        const counts = {
                            totalWeComUsers: getCount('totalWeComUsers', 'TotalWeComUsers'),
                            matchedUsers: getCount('matchedUsers', 'MatchedUsers'),
                            updatedUsers: getCount('updatedUsers', 'UpdatedUsers'),
                            createdUsers: getCount('createdUsers', 'CreatedUsers'),
                            skippedAlreadyBound: getCount('skippedAlreadyBound', 'SkippedAlreadyBound'),
                            skippedNoMatch: getCount('skippedNoMatch', 'SkippedNoMatch'),
                            skippedAmbiguous: getCount('skippedAmbiguous', 'SkippedAmbiguous'),
                        };
                        const stats = [
                            ['总人数', counts.totalWeComUsers],
                            ['匹配', counts.matchedUsers],
                            ['更新', counts.updatedUsers],
                            ['新增', counts.createdUsers],
                            ['已绑定跳过', counts.skippedAlreadyBound],
                            ['未匹配', counts.skippedNoMatch],
                            ['多匹配', counts.skippedAmbiguous],
                        ].filter((item) => item[1] > 0);
                        const summary = stats.length
                            ? `同步完成：${stats.map((item) => `${item[0]} ${item[1]}`).join('，')}`
                            : '';
                        const message = summary ? `企业微信同步成功，${summary}` : '企业微信同步成功';

                        this.$notification.success({
                            message,
                            description: undefined,
                        });
                    });
            },

            /**
             * 添加
             */
            Create() {
                ModalHelper.create(
                    CreateOrEditLoginUser,
                    {},
                    {
                        width: '800px',
                    }
                ).subscribe((res) => {
                    if (res) {
                        this.search();
                    }
                });
            },
            /**
             * 编辑
             * @returns {any}
             * @constructor
             */
            Edit() {
                if (this.selectedRows.length <= 0) {
                    return abp.message.warn('请至少选择一项进行操作');
                }
                if (this.selectedRows.length > 1) {
                    return abp.message.warn('只能选择一项进行操作');
                }
                ModalHelper.create(
                    CreateOrEditLoginUser,
                    { id: this.selectedRows[0].id },
                    {
                        width: '800px',
                    }
                ).subscribe((res) => {
                    if (res) {
                        this.search();
                    }
                });
            },
            /**
             * 批量删除
             * @constructor
             */
            BatchDelete() {
                if (this.selectedRows.length <= 0) {
                    return abp.message.warn('请至少选择一项进行操作');
                }
                this.$confirm({
                    title: this.l('ConfirmOperation'),
                    content: '你确认删除这' + this.selectedRows.length + '项吗？',
                    okText: '确认',
                    cancelText: '取消',
                    onOk: () => {
                        let ids = _.map(this.selectedRows, 'id');
                        this.loading = true;
                        this._userServiceProxy
                            .batchDelete(ids)
                            .finally(() => {
                                this.loading = false;
                            })
                            .then((res) => {
                                this.search();
                                this.$notification['success']({
                                    message: this.l('SuccessfullyDeleted'),
                                });
                            });
                    },
                });
            },
            /**
             * 解锁
             */
            unlockTenantAdminUser() {
                if (this.selectedRows.length <= 0) {
                    return abp.message.warn('请至少选择一项进行操作');
                }
                if (this.selectedRows.length > 1) {
                    return abp.message.warn('只能选择一项进行操作');
                }
                this.loading = true;
                this._userServiceProxy
                    .unlock({
                        id: this.selectedRows[0].id,
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    .then(() => {
                        this.search();
                        this.$notification['success']({
                            message: this.l('解锁成功'),
                        });
                    });
            },
            /**
             * 功能授权 （type:1角色；2用户；3部门；）
             * @param id
             */
            userAuthorize() {
                if (this.selectedRows.length <= 0) {
                    return abp.message.warn('请至少选择一项进行操作');
                }
                if (this.selectedRows.length > 1) {
                    return abp.message.warn('只能选择一项进行操作');
                }
                ModalHelper.create(
                    Authorize,
                    {
                        Id: this.selectedRows[0].id,
                        type: 2,
                        headerTitle: this.selectedRows[0].realName
                            ? this.selectedRows[0].realName
                            : this.selectedRows[0].userName,
                    },
                    {
                        width: '600px',
                    }
                ).subscribe((res) => {
                    if (res) {
                        this.search();
                    }
                });
            },
            interfaceAuthorize() {
                if (this.selectedRows.length <= 0) {
                    return abp.message.warn('请至少选择一项进行操作');
                }
                if (this.selectedRows.length > 1) {
                    return abp.message.warn('只能选择一项进行操作');
                }
                console.log(this.selectedRows);
                ModalHelper.create(
                    InterfaceAuthorize,
                    {
                        type: 2,
                        ObjectId: this.selectedRows[0].id,
                        headertitle: this.selectedRows[0].realName,
                    },
                    { width: '1000px' }
                ).subscribe((res) => { });
            },
            restrictClient(record) {
                ModalHelper.create(
                    RestrictClient,
                    {
                        type: 2,
                        ObjectId: this.selectedRows[0].id,
                        headertitle: this.selectedRows[0].realName,
                    },
                    { width: '500px' }
                ).subscribe((res) => { });
            },
            /**
             * 权限
             */
            editUserPermissions() {
                if (this.selectedRows.length <= 0) {
                    return abp.message.warn('请至少选择一项进行操作');
                }
                if (this.selectedRows.length > 1) {
                    return abp.message.warn('只能选择一项进行操作');
                }
                ModalHelper.create(
                    EditUserPermissionsComponent,
                    { id: this.selectedRows[0].id, userName: this.selectedRows[0].userName },
                    {
                        width: '900px',
                    }
                ).subscribe((res) => {
                    if (res) {
                        this.search();
                    }
                });
            },
            /**
             * 使用此账户登录
             */
            tenantImpersonateLogin() {
                if (this.selectedRows.length <= 0) {
                    return abp.message.warn('请至少选择一项进行操作');
                }
                if (this.selectedRows.length > 1) {
                    return abp.message.warn('只能选择一项进行操作');
                }

                impersonationService.impersonate(this.selectedRows[0].id, this._appSessionService.tenantId);
            },
            emptyUserToken() {
                if (this.selectedRowKeys.length <= 0) {
                    return abp.message.warn('请至少选择一项进行操作');
                }
                this.$confirm({
                    title: this.l('ConfirmOperation'),
                    content: '你确认要清除这' + this.selectedRowKeys.length + '项账号的缓存数据吗？',
                    okText: '确认',
                    cancelText: '取消',
                    onOk: () => {
                        this.loading = true;
                        this._userServiceProxy
                            .emptyUserToken(this.selectedRowKeys)
                            .finally(() => {
                                this.loading = false;
                            })
                            .then((res) => {
                                this.search();
                                this.$notification['success']({
                                    message: this.l('清除成功'),
                                });
                            });
                    },
                });
            },
        },
    };
</script>

<style scoped></style>



